import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import OverviewClaimsCreated from './components/biReports/OverviewClaimsCreated';
import OverviewClaimsConsumed from './components/biReports/OverviewClaimsConsumed';
import OverviewClaimConversion from './components/biReports/OverviewClaimConversion';
import OverviewOrdersWithClaims from './components/biReports/OverviewOrdersWithClaims';

import OverviewSalesFromClaims from './components/biReports/OverviewSalesFromClaims';
import OverviewDiscountFromClaims from './components/biReports/OverviewDiscountFromClaims';
import OverviewAverageDiscount from './components/biReports/OverviewAverageDiscount';
import OverviewOpenClaims from './components/biReports/OverviewOpenClaims';

import PromotionsEvolution from './components/biReports/PromotionsEvolution';
import PromotionsPerformanceByPromotion from './components/biReports/PromotionsPerformanceByPromotion';
import PromotionsOpenClaimsByPromotion from './components/biReports/PromotionsOpenClaimsByPromotion';
import PromotionsOrdersByLocation from './components/biReports/PromotionsOrdersByLocation';

import Client from './components/Client';

class RapPromotions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      edit: false,
      periodMode: "last_30d",
    };
  }

  componentDidMount() {
    if (this.props.onReady) {
      this.props.onReady();
    }
  }

  componentWillUnmount() {
  }

  handlePeriodChange = (event, newPeriodMode) => {
    if (!newPeriodMode) return;

    this.setState({
      periodMode: newPeriodMode,
    });
  };

  render() {
    const { periodMode } = this.state;

    const fullWidthChildSx = {
      width: '100%',
      minWidth: 0,
      '& > *': {
        width: '100% !important',
        maxWidth: '100% !important',
        mx: '0 !important',
        boxSizing: 'border-box',
      },
    };

    const reportBoxSx = {
      width: '100%',
      minWidth: 0,
      height: {
        xs: 380,
        sm: 420,
        md: 460,
        lg: 500,
      },
      minHeight: 0,
      overflow: 'hidden',
      borderRadius: {
        xs: '14px',
        sm: '16px',
      },
      boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
      border: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      boxSizing: 'border-box',

      '& > *': {
        width: '100% !important',
        maxWidth: '100% !important',
        height: '100% !important',
        maxHeight: '100% !important',
        minHeight: '0 !important',
        mx: '0 !important',
        boxSizing: 'border-box',
      },

      '& .MuiCard-root': {
        width: '100% !important',
        height: '100% !important',
        maxHeight: '100% !important',
        minHeight: '0 !important',
        borderRadius: {
          xs: '14px',
          sm: '16px',
        },
        boxShadow: 'none',
        border: 'none',
        overflow: 'hidden',
        boxSizing: 'border-box',
      },

      '& .MuiCardContent-root': {
        height: '100%',
        maxHeight: '100%',
        minHeight: 0,
        boxSizing: 'border-box',
      },
    };

    return (
      <Box
        component="main"
        sx={{
          // bgcolor: '#f4f7fb',
          minHeight: '100vh',
          flexGrow: 1,
          width: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          maxWidth: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          ml: {
            xs: 'calc(50% - 50vw + 4px)',
            sm: 0,
          },
          overflowX: 'hidden',
          pt: { xs: 0.75, sm: 1.5, md: 3 },
          pb: { xs: 1, sm: 2, md: 3 },
          px: { xs: 0.5, sm: 1, md: 2 },
          boxSizing: 'border-box',

          '& .MuiGrid-item': {
            minWidth: 0,
          },
          '& .MuiCard-root': {
            maxWidth: '100%',
            boxSizing: 'border-box',
          },
        }}
      >
        <Grid
          container
          spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
          sx={{
            width: '100%',
            maxWidth: '100%',
            m: 0,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              p: '0 !important',
              mb: { xs: 0.75, md: 1.25 },
            }}
          >
            <Stack
              direction="row"
              spacing={{ xs: 1, sm: 1.5 }}
              alignItems="center"
              justifyContent="space-between"
              sx={{
                width: '100%',
                px: { xs: 1.25, sm: 1.75, md: 2 },
                py: { xs: 1.25, sm: 1.5, md: 1.75 },
                bgcolor: '#ffffff',
                borderRadius: { xs: '14px', sm: '16px' },
                border: '1px solid rgba(15, 23, 42, 0.06)',
                boxShadow: '0 4px 14px rgba(15, 23, 42, 0.06)',
                boxSizing: 'border-box',
              }}
            >
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '1rem', sm: '1.15rem', md: '1.35rem' },
                    lineHeight: 1.2,
                    color: '#020617',
                  }}
                >
                  Promotions
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mt: 0.25,
                    color: '#475569',
                    fontSize: { xs: '0.72rem', sm: '0.82rem' },
                  }}
                >
                  Promo claims, usage, sales impact and discount cost
                </Typography>
              </Box>

              <ToggleButtonGroup
                exclusive
                size="small"
                value={periodMode}
                onChange={this.handlePeriodChange}
                sx={{
                  alignSelf: 'center',
                  flexShrink: 0,
                  bgcolor: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.06)',
                  '& .MuiToggleButtonGroup-grouped': {
                    borderColor: 'rgba(15, 23, 42, 0.08)',
                  },
                  '& .MuiToggleButton-root': {
                    minWidth: { xs: 34, sm: 42 },
                    px: { xs: 0.75, sm: 1.25 },
                    py: { xs: 0.35, sm: 0.45 },
                    fontSize: { xs: '0.66rem', sm: '0.75rem' },
                    fontWeight: 700,
                    textTransform: 'none',
                    color: '#334155',
                    borderColor: 'rgba(15, 23, 42, 0.08)',
                    '&.Mui-selected': {
                      bgcolor: '#0f172a',
                      color: '#fff',
                      '&:hover': {
                        bgcolor: '#111827',
                      },
                    },
                  },
                }}
              >
                <ToggleButton value="last_7d">7d</ToggleButton>
                <ToggleButton value="last_30d">30d</ToggleButton>
                <ToggleButton value="last_90d">90d</ToggleButton>
              </ToggleButtonGroup>
            </Stack>
          </Grid>

          <Grid item xs={12} sx={{ p: '0 !important' }}>
            <Grid
              container
              spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
              sx={{
                width: '100%',
                m: 0,
              }}
            >
              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewClaimsCreated periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewClaimsConsumed periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewClaimConversion periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewOrdersWithClaims periodMode={periodMode} />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ p: '0 !important', mt: { xs: 0.75, md: 1.5 } }}>
            <Grid
              container
              spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
              sx={{
                width: '100%',
                m: 0,
              }}
            >
              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewSalesFromClaims periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewDiscountFromClaims periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewAverageDiscount periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewOpenClaims periodMode={periodMode} />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={8}
            sx={{
              pl: { xs: '0 !important', md: undefined },
              mt: { xs: 0.75, md: 1.5 },
            }}
          >
            <Box sx={reportBoxSx}>
              <PromotionsEvolution periodMode={periodMode} />
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={4}
            sx={{
              mt: { xs: 0.75, md: 1.5 },
            }}
          >
            <Box sx={reportBoxSx}>
              <PromotionsOrdersByLocation periodMode={periodMode} />
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={8}
            sx={{
              pl: { xs: '0 !important', md: undefined },
            }}
          >
            <Box
              sx={{
                ...reportBoxSx,
                height: {
                  xs: 460,
                  sm: 500,
                  md: 540,
                  lg: 580,
                },
              }}
            >
              <PromotionsPerformanceByPromotion periodMode={periodMode} />
            </Box>
          </Grid>

          <Grid item xs={12} md={12} lg={4}>
            <Box
              sx={{
                ...reportBoxSx,
                height: {
                  xs: 460,
                  sm: 500,
                  md: 540,
                  lg: 580,
                },
              }}
            >
              <PromotionsOpenClaimsByPromotion periodMode={periodMode} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default RapPromotions;